<script>
import appConfig from '@src/app.config';

export default {
  props: ['filters', 'name'],
  data() {
    return {
      dsbl_btn: false,
      loading: true,

      outputs: {
        "App\\User": { name: 'name', url: '/contacts/' },
        "App\\Favorite": { name: 'name', url: '' },
        "coryallen\\Blogs\\Models\\Blog": { name: 'title', url: '/blogs/' },
        "coryallen\\Carts\\Models\\Cart": { name: 'for_address', url: '/carts/' },
        "coryallen\\Docs\\Models\\Docs": { name: 'title', url: '/docs/' },
        "coryallen\\Docs\\Models\\DocsSections": { name: 'title', url: '/docs/' },
        "coryallen\\Faqs\\Models\\Faq": { name: 'title', url: '/faqs/' },
        "coryallen\\Inbox\\Models\\Inbox": { name: 'subject', url: '/inbox/' },
        "coryallen\\Listings\\Models\\Listing": { name: 'Address', url: '/listings/' },
        "coryallen\\Mlss\\Models\\Mls": { name: 'title', url: '/mlss/' },
        "coryallen\\Mlss\\Models\\MlsListing": { name: 'Address', url: '' },
        "coryallen\\Mlss\\Models\\MlsPdf": { name: 'title', url: '/mlss/' },
        "coryallen\\Pages\\Models\\Page": { name: 'title', url: '/pages/' },
        "coryallen\\Services\\Models\\Package": { name: 'title', url: '/packages/' },
        "coryallen\\Services\\Models\\Service": { name: 'title', url: '/packages/' },
        "coryallen\\Tasks\\Models\\Task": { name: 'title', url: '/tasks/' },
        "coryallen\\Testimonials\\Models\\Testimonial": { name: 'posted_by', url: '/testimonials/' },
        "coryallen\\Trackers\\Models\\Tracker": { name: 'title', url: '/trackers/' },
        "coryallen\\Vendors\\Models\\Vendor": { name: 'title', url: '/vendors/' },
        "coryallen\\Websites\\Models\\Website": { name: 'title', url: '/websites/' },
      },

      communications: [],
      pagination: {},

      edit_com: {},

      active_tab: '',
      all_count: 0,
      note_count: 0,
      activity_count: 0,

      default_new_note: {
        private: this.hasRole(['Dev','Admin']) ? 1 : 0,
        onable_id: this.filters.onable_id,
        onable_type: this.filters.onable_type,
        byable_id: '',
        byable_type: '',
        type: 'Note',
        direction: 'outbound',
        text_body: '',
      },
      new_note: {},
    }
  },
  watch: {
    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},

    // 'filters.types': { handler: function(n, o) {
    //   for(var i in this.filters.types) { this.active_tab = this.filters.types[i]; return; }
    // }, immediate: true },
  },
  created() {
    this.new_note = JSON.parse(JSON.stringify(this.default_new_note));

    if(this.name != "All") { this.filters.only = "Note"; this.active_tab = "Note"; }

    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/communications/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.communications = res.data.data.data;
        this.filters.total = res.data.data.total;
        this.pagination = res.data.data;
        this.all_count = res.data.all_count;
        this.note_count = res.data.note_count;
        this.activity_count = res.data.activity_count;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    add_note() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/communications/store', this.new_note).then(res => {
        // console.log(res);
        this.new_note = JSON.parse(JSON.stringify(this.default_new_note));
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    update_com() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/communications/update', this.edit_com).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.edit_com = {};
        this.$refs.modal_edit_com.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_com() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.edit_com.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this note?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/communications/delete/'+this.edit_com.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.edit_com = {};
              this.$refs.modal_edit_com.hide();
              this.fetchData();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    setTab(item) {
      this.filters.only = item;
      this.fetchData();
    },

  }
}
</script>

<template>
  <div class="">

    <b-modal ref="modal_edit_com" centered size="lg" title="Update Communication" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <form @submit.prevent="update_com" method="post">
        <div class="p-3">
          <w-field SimpleDataType="Textarea" Title="Note :" v-model="edit_com.text_body"></w-field>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button v-if="edit_com.id" type="button" class="btn btn-danger mr-auto ml-0" @click="delete_com" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete</button>
          <button type="button" class="btn btn-light" @click="$refs.modal_edit_com.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
          <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line"></Icon> Save</button>
        </footer>
      </form>
    </b-modal>

    <div v-if="filters.types.includes('Note') && name != 'All'" class="mb-3">

      <ul class="nav nav-tabs">
        <li role="presentation" class="nav-item">
          <a v-if="filters.types.includes('Note')" class="nav-link" :class="active_tab == 'Note' ? 'active' : ''" data-toggle="tab" href="#nav-notes"><Icon icon="ri:message-2-fill" width="21" /> Add Note</a>
        </li>
      </ul>

      <div class="tab-content p-3 bg-white border border-light border-top-0 rounded-bottom">
        <div v-if="filters.types.includes('Note')" class="tab-pane fade" :class="active_tab == 'Note' ? 'show active' : ''" id="nav-notes" role="tabpanel">
          <form class="" @submit.prevent="add_note" method="post">
            <div class="row">
              <div v-if="hasRole(['Dev','Admin'])" class="col-1 _w-n-200">
                <label class="_f-capitalize" style="left:10px" title="Privacy determines who will be able to see the content you post. When Everyone is selected anyone who is able to login to this system will be able to view your content." v-tippy>Privacy <Icon icon="ri:question-line" /></label>
                <select class="form-control" v-model="new_note.private" name="phone">
                  <option value="1">{{app_name}} only</option>
                  <option value="0">Everyone</option>
                </select>
              </div>
              <div class="col">
                <label>Message</label>
                <textarea class="form-control" name="message" rows="1" v-model="new_note.text_body" placeholder="Type your note..."></textarea>
              </div>
              <div class="col-2 align-self-end">
                <button type="submit" class="btn btn-block btn-primary">Send</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <ul v-if="filters.types.includes('Note')" class="nav nav-tabs">
        <li role="presentation" class="nav-item">
          <a @click="setTab('')" class="nav-link" :class="name == 'All' ? 'active' : ''" data-toggle="tab" href="#snav-all" v-tippy content="All"><i v-if="loading" class="spinner-border spinner-border-sm mr-1"></i> All<span class="ml-1 _f-w-400 text-muted" v-if="all_count > 0">({{all_count}})</span></a>
        </li>
        <li role="presentation" class="nav-item">
          <a @click="setTab('Note')" v-if="filters.types.includes('Note')" class="nav-link" :class="name != 'All' ? 'active' : ''" data-toggle="tab" href="#snav-notes" v-tippy content="Notes"><i v-if="loading" class="spinner-border spinner-border-sm mr-1"></i><Icon icon="ri:message-2-fill" width="21" /><span class="ml-1 _f-w-400 text-muted" v-if="note_count > 0">({{note_count}})</span></a>
        </li>
        <li role="presentation" class="nav-item">
          <a @click="setTab('Activity')" v-if="filters.types.includes('Activity')" class="nav-link" data-toggle="tab" href="#snav-activities" v-tippy content="Activities"><i v-if="loading" class="spinner-border spinner-border-sm mr-1"></i><Icon icon="ri:footprint-fill" width="21" /><span class="ml-1 _f-w-400 text-muted" v-if="activity_count > 0">({{activity_count}})</span></a>
        </li>
      </ul>

      <div v-if="!filters.types.includes('Note')" class="p-3 bg-white border border-top-0 rounded-bottom">
        <div class="header">
          <ul class="list-inline header-menu">
            <li class="list-inline-item"><h2><strong>Recent</strong> Activities</h2></li>
          </ul>
        </div>
      </div>
      <div class="p-4 bg-white border border-light border-top-0 rounded-bottom">

        <div class="pl-2 mb-3">
          <div v-for="(item, index) in communications" :key="item.id" class="border-left pb-3 pl-2">
            <div class="position-relative mb-2 ml-4 p-3 border border-light rounded _of-break _h-n-50">
              <div v-if="item.type == 'Note'" class="rounded-circle _w-40 _h-40 _lh-40 text-center text-white position-absolute _pos-t-10 _pos-l-n-54 bg-warning">
                <Icon icon="ri:message-2-fill" width="19" />
              </div>
              <div v-else-if="item.type == 'Activity'" class="rounded-circle _w-40 _h-40 _lh-40 text-center text-white position-absolute _pos-t-10 _pos-l-n-54 bg-muted">
                <Icon icon="ri:footprint-fill" width="19" />
              </div>
              <div v-else class="rounded-circle _w-40 _h-40 _lh-40 text-center text-white position-absolute _pos-t-10 _pos-l-n-54 bg-dark">
                <Icon icon="ri:alert-fill" width="19" />
              </div>
              <div class="row m-0">
                <div class="_w-50 mr-2">
                  <div v-if="item.direction == 'inbound'">
                    <avatar :username="item.onable ? item.onable[outputs[item.onable_type].name] : 'Unknown'" :size="50" :rounded="false" class="rounded"></avatar>
                  </div>
                  <div v-else-if="item.byable">
                    <router-link :to="'/contacts/'+item.byable.id" tag="a" v-tippy title="View profile">
                      <avatar :username="item.byable.name" :src="formatImage(item.byable.avatar)" :size="50" :rounded="false" class="rounded"></avatar>
                    </router-link>
                  </div>
                  <div v-else>
                    <avatar :username="'Unknown'" :size="50" :rounded="false" class="rounded"></avatar>
                  </div>
                </div>
                <div class="col p-0">

                  <button v-if="item.type == 'Note' && (item.byable_id == user.id && item.byable_type == 'App\\User')" type="button" class="btn btn-sm btn-white float-right" v-tippy content="Edit/Delete" @click="edit_com = JSON.parse(JSON.stringify(item)); $refs.modal_edit_com.show()"><Icon icon="ri:edit-2-line" /></button>

                  <div class="h6 mb-1">
                    <span v-if="item.direction == 'inbound'" v-tippy :content="outputs[item.onable_type].url">{{item.onable ? item.onable[outputs[item.onable_type].name] : 'Unknown'}}</span><span v-else v-tippy :content="outputs[item.byable_type].url">{{(item.byable ? item.byable.name : 'Unknown')}}</span>
                    <Icon icon="ri:arrow-right-line" class="text-muted mx-2" />
                    <span v-if="item.direction == 'inbound'" v-tippy :content="outputs[item.byable_type].url">{{(item.byable ? item.byable.name : 'Unknown')}}</span><span v-else v-tippy :content="outputs[item.onable_type].url">
                      <span v-if="item.onable">
                        <router-link v-if="outputs[item.onable_type].url" :to="outputs[item.onable_type].url+item.onable.id" tag="a">{{ item.onable[outputs[item.onable_type].name] }}</router-link>
                        <span v-else>{{ item.onable[outputs[item.onable_type].name] }}</span>
                      </span>
                      <span v-else>Unknown</span>
                    </span>
                  </div>
                  <div class="text-muted small"><small>{{moment(item.created_at).format('lll')}} ({{moment(item.created_at).fromNow()}})</small></div>

                </div>
              </div>

              <!-- Note Display -->

              <!-- Text Display -->

              <!-- Activity Display -->
              <div class="small">
                <div class="mt-2 _of-pre">{{item.text_body}}</div>
                <div v-if="item.changes" class="mt-3 small">
                  <span v-for="(change, change_i) in item.changes" :key="change_i" class="d-inline-block border border-light rounded text-muted font-weight-normal px-1 mr-1 mt-1 small"><strong>{{change_i}}</strong> changed from "{{change.old}}" to "{{change.new}}"</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <w-pagination class="mt-4" :pagination="pagination" @paginate="communications=[]; fetchData()" :offset="3"></w-pagination>
      </div>

    </div>

  </div>
</template>

<style lang="scss" scoped>


</style>
